import { Component, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';

interface Asset {
  id: number,
  name: string,
  size: number,
  content_type: string;
}

interface Release {
  tagName: string,
  publishedAt: Date,
  body: string,
  assets: Asset[];
}

@Component({
    selector: 'app-deploy-webapp',
    templateUrl: './deploy-webapp.component.html',
    styleUrls: ['./deploy-webapp.component.scss'],
    standalone: false
})
export class DeployWebappComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private sharedService = inject(SharedService);

  releaseList: Release[] = [];

  ngOnInit(): void {
    this.getServerRelease();
  }

  getServerRelease() {
    const xhttp = this.restApi.getRequest(this.constructApi.getWebsiteReleases());
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          const assets = this.processReleaseAsset(json.assets);
          const release = { tagName: json.tag_name, publishedAt: new Date(json.published_at), body: json.body, assets: assets };
          // console.log(release.publishedAt)
          this.releaseList.push(release);
        });

        this.releaseList.sort((a, b) => ((a.publishedAt > b.publishedAt)) ? -1 : 1);
      }
    };
  }

  processReleaseAsset(jsonArr: any) {
    const assetArr: Asset[] = [];
    if (jsonArr != undefined) {
      jsonArr.forEach(json => {
        const asset = { id: json.id, name: json.name, size: json.size, content_type: json.content_type }
        assetArr.push(asset);
      });

      return assetArr;
    }
  }

  pushThisRelease(tag: string, filename: string) {
    const xhr = this.restApi.postRequest(this.constructApi.getUpdateWebAppRelease(tag, filename));
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        this.sharedService.openAlert("Successfully pushed to " + tag + "!", ALERT_TYPE.SUCCESS);
      }
    }
  }

  reset() {
    this.activeModal.close();
  }
}
